



























































































import { Component } from 'vue-property-decorator';
import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import ReCAPTCHA from '@/components/ReCAPTCHA.vue';
import ReCAPTCHABranding from '@/components/ReCAPTCHABranding.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';

import * as JwtUtil from '@/common/JwtUtil';
import * as StringUtil from '@/common/StringUtil';
import * as Msgs from '@/common/Messages';

import LoginParam from '@/models/account/LoginParam';
import PreRegistParam from '@/models/account/PreRegistParam';
import RepositoryFactory from '@/repository/RepositoryFactory';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
      're-captcha-branding': ReCAPTCHABranding,
    },
  },
)
export default class Login extends BaseView {
  private rankCode = '';

  private loginParam = new LoginParam();

  private preRegistParam = new PreRegistParam();

  private reCAPTCHA = new ReCAPTCHA();

  private isIndicatorDisplay = false;

  private isLoginFail = false;

  private isIdEmpty = false;

  private isPasswordEmpty = false;

  private isEmailEmpty = false;

  private isEmailConfirmEmpty = false;

  private isTermChecked = false;

  private isPreRegistFail = false;

  private preRegistFailMessage = '';

  private msgs = Msgs;

  // eslint-disable-next-line class-methods-use-this
  private created() {
    JwtUtil.deleteJwt();
  }

  private mounted() {
    const { rank } = this.$route.query;
    if (!StringUtil.isEmpty(rank)) {
      this.rankCode = String(rank);
    }

    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    const LoginCss = document.createElement('link');
    LoginCss.rel = 'stylesheet';
    LoginCss.href = '/account/css/login.css';
    this.$el.appendChild(LoginCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * ログイン処理を行います。
   * ログインが成功した場合、SessionStorageにJWTを登録し、遷移先かマイページ画面に遷移します。
   */
  async login() {
    this.isIdEmpty = StringUtil.isEmpty(this.loginParam.userId);
    this.isPasswordEmpty = StringUtil.isEmpty(this.loginParam.password);
    if (this.isIdEmpty || this.isPasswordEmpty) return;

    try {
      this.isIndicatorDisplay = true;
      const AccountRepository = RepositoryFactory.get().account;
      await AccountRepository.login(this.loginParam).then((response) => {
        const responseData = response.data;
        JwtUtil.setJwt(responseData.access_token);
        const returnPath = sessionStorage.getItem(JwtUtil.SESSION_RETURN_PATH_KEY);
        sessionStorage.removeItem(JwtUtil.SESSION_RETURN_PATH_KEY);
        if (!StringUtil.isEmpty(this.rankCode)) {
          this.$router.replace(`${this.paths.ACCOUNT_CONFIRM}?rank=${this.rankCode}`);
        } else if (returnPath) {
          this.$router.replace(returnPath);
        } else {
          this.$router.replace(this.paths.MY_PAGE);
        }
      }).catch(() => {
        this.isLoginFail = true;
      });
    } catch (e) {
      this.isLoginFail = true;
    } finally {
      this.isIndicatorDisplay = false;
    }
  }

  /**
   * 仮会員登録処理を行います。
   * 仮会員登録処理が成功した場合、仮登録完了画面に遷移します。
   */
  async preRegist() {
    this.isIndicatorDisplay = false;
    this.isPreRegistFail = false;
    this.isEmailEmpty = StringUtil.isEmpty(this.preRegistParam.email);
    this.isEmailConfirmEmpty = StringUtil.isEmpty(this.preRegistParam.emailConfirm);
    if (this.isEmailEmpty || this.isEmailConfirmEmpty || !this.isTermChecked) return;

    // メールアドレスの形式チェック
    const mailReg = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!mailReg.test(this.preRegistParam.email as string)) {
      this.isPreRegistFail = true;
      this.preRegistFailMessage = Msgs.ILLEGAL_MAIL_ADDRESS;
      return;
    }

    if (this.preRegistParam.email !== this.preRegistParam.emailConfirm) {
      this.isPreRegistFail = true;
      this.preRegistFailMessage = Msgs.MAIL_ADDRESS_MISMATCH;
      return;
    }

    try {
      this.isIndicatorDisplay = true;

      await this.reCAPTCHA.getToken('register')
        .then((token) => {
          this.preRegistParam.reCaptchaToken = token;
        });
      const AccountRepository = RepositoryFactory.get().account;
      if (!StringUtil.isEmpty(this.rankCode)) {
        this.preRegistParam.examRankCode = StringUtil.decodeFromBase64Url(this.rankCode);
      }
      await AccountRepository.preRegist(this.preRegistParam).then((response) => {
        if (response.status === 201) {
          this.$router.replace(this.paths.PRE_REGIST);
        } else {
          this.isPreRegistFail = true;
          this.preRegistFailMessage = Msgs.PRE_REGISTER_FAILURE;
        }
      }).catch(() => {
        this.isPreRegistFail = true;
        this.preRegistFailMessage = Msgs.PRE_REGISTER_FAILURE;
      });
    } catch (e) {
      this.isPreRegistFail = true;
      this.preRegistFailMessage = Msgs.PRE_REGISTER_FAILURE;
    } finally {
      this.isIndicatorDisplay = false;
    }
  }

  /**
   * 利用規約チェックの切り替え
   */
  termCheck() {
    this.isTermChecked = !this.isTermChecked;
  }
}
